export const STRINGCONSTANTS = {
  HISTORIC: 'historic',
  PREDICTION: 'prediction',
  CLYDE: 'clyde',
  HISTORY: 'history',
  IMAGING_SENSOR: 'imagingSensor',
  NON_IMAGING_SENSOR: 'nonImagingSensor',
};

